import InventoryMerchDetailTabComponent from './InventoryMerchDetailTab';

const InventoryMerchDetailTab = InventoryMerchDetailTabComponent;

export default InventoryMerchDetailTab;
